module.exports = __webpack_public_path__ + "img/pool.d5db3093.svg";